import { ArrowRight, BarChart3, BookOpen, Building2, CalendarClock, Car, ClipboardCheck, ClipboardList, Factory, FolderArchive, GraduationCap, Scale, Target, TrendingUp } from "lucide-react";

type Props = {
  onOpenManual: () => void;
  onOpenIndicadores: () => void;
  onOpenBiblioteca: () => void;
  onOpenDafo: () => void;
  onOpenIncidencias: () => void;
  onOpenSuministradores: () => void;
  onOpenRequisitosLegales: () => void;
  onOpenObjetivos: () => void;
  onOpenPlanificacionCambios: () => void;
  onOpenRiesgosOportunidades: () => void;
  onOpenMantenimientoVehiculos: () => void;
  onOpenMantenimientoInfraestructuras: () => void;
  onOpenControlOperacional: () => void;
  onOpenFormacion: () => void;
};

export function Iso900114001Hub({
  onOpenManual,
  onOpenIndicadores,
  onOpenBiblioteca,
  onOpenDafo,
  onOpenIncidencias,
  onOpenSuministradores,
  onOpenRequisitosLegales,
  onOpenObjetivos,
  onOpenPlanificacionCambios,
  onOpenRiesgosOportunidades,
  onOpenMantenimientoVehiculos,
  onOpenMantenimientoInfraestructuras,
  onOpenControlOperacional,
  onOpenFormacion,
}: Props) {
  return (
    <section className="calidad-hub-grid">
      <button
        type="button"
        onClick={onOpenManual}
        className="calidad-hub-card"
      >
        <span className="calidad-hub-card-icon">
          <BookOpen size={22} />
        </span>

        <div className="calidad-hub-card-body">
          <div className="calidad-hub-card-eyebrow">Documento compartido</div>
          <h2 className="calidad-hub-card-title">Manual del Sistema Integrado</h2>
          <p className="calidad-hub-card-copy">
            Consulta el manual vigente compartido con ISO 27001-27701, descarga el Word original y gestiona su control documental.
          </p>
        </div>

        <span className="calidad-hub-card-action">
          Abrir
          <ArrowRight size={16} />
        </span>
      </button>

      <button
        type="button"
        onClick={onOpenIndicadores}
        className="calidad-hub-card"
      >
        <span className="calidad-hub-card-icon">
          <BarChart3 size={22} />
        </span>

        <div className="calidad-hub-card-body">
          <div className="calidad-hub-card-eyebrow">Sección compartida</div>
          <h2 className="calidad-hub-card-title">Indicadores</h2>
          <p className="calidad-hub-card-copy">
            Consulta y actualiza los nueve indicadores compartidos, sus valores de referencia, seguimiento, gráficos y control documental.
          </p>
        </div>

        <span className="calidad-hub-card-action">
          Abrir
          <ArrowRight size={16} />
        </span>
      </button>

      <button
        type="button"
        onClick={onOpenBiblioteca}
        className="calidad-hub-card"
      >
        <span className="calidad-hub-card-icon">
          <FolderArchive size={22} />
        </span>

        <div className="calidad-hub-card-body">
          <div className="calidad-hub-card-eyebrow">ISO 9001-14001</div>
          <h2 className="calidad-hub-card-title">Biblioteca</h2>
          <p className="calidad-hub-card-copy">
            Consulta la documentación de Oficina, Medioambiente y Proveedores vinculada a Calidad y Medioambiente.
          </p>
        </div>

        <span className="calidad-hub-card-action">
          Abrir
          <ArrowRight size={16} />
        </span>
      </button>

      <button
        type="button"
        onClick={onOpenIncidencias}
        className="calidad-hub-card"
      >
        <span className="calidad-hub-card-icon">
          <ClipboardList size={22} />
        </span>

        <div className="calidad-hub-card-body">
          <div className="calidad-hub-card-eyebrow">ISO 9001-14001</div>
          <h2 className="calidad-hub-card-title">Incidencias</h2>
          <p className="calidad-hub-card-copy">
            Consulta el registro historico de incidencias de calidad con
            clasificacion Q/MA, NCp/Df y comentarios de cierre o auditoria.
          </p>
        </div>

        <span className="calidad-hub-card-action">
          Abrir
          <ArrowRight size={16} />
        </span>
      </button>

      <button
        type="button"
        onClick={onOpenSuministradores}
        className="calidad-hub-card"
      >
        <span className="calidad-hub-card-icon">
          <Factory size={22} />
        </span>

        <div className="calidad-hub-card-body">
          <div className="calidad-hub-card-eyebrow">ISO 9001-14001</div>
          <h2 className="calidad-hub-card-title">Suministradores Homologados</h2>
          <p className="calidad-hub-card-copy">
            Gestiona proveedores homologados indirectos, directos y del grupo
            con alta, edicion, borrado y consulta rapida de sus marcas.
          </p>
        </div>

        <span className="calidad-hub-card-action">
          Abrir
          <ArrowRight size={16} />
        </span>
      </button>

      <button
        type="button"
        onClick={onOpenRequisitosLegales}
        className="calidad-hub-card"
      >
        <span className="calidad-hub-card-icon">
          <Scale size={22} />
        </span>

        <div className="calidad-hub-card-body">
          <div className="calidad-hub-card-eyebrow">ISO 9001-14001</div>
          <h2 className="calidad-hub-card-title">Requisitos Legales</h2>
          <p className="calidad-hub-card-copy">
            Consulta y mantiene las referencias normativas, sus requisitos,
            periodicidades, registros a obtener y cumplimiento asociado.
          </p>
        </div>

        <span className="calidad-hub-card-action">
          Abrir
          <ArrowRight size={16} />
        </span>
      </button>

      <button
        type="button"
        onClick={onOpenObjetivos}
        className="calidad-hub-card"
      >
        <span className="calidad-hub-card-icon">
          <Target size={22} />
        </span>

        <div className="calidad-hub-card-body">
          <div className="calidad-hub-card-eyebrow">ISO 9001-14001</div>
          <h2 className="calidad-hub-card-title">Objetivos</h2>
          <p className="calidad-hub-card-copy">
            Gestiona objetivos de calidad y medioambiente con ficha, etapas, seguimiento, cierre, firma y anexos.
          </p>
        </div>

        <span className="calidad-hub-card-action">
          Abrir
          <ArrowRight size={16} />
        </span>
      </button>


      <button
        type="button"
        onClick={onOpenPlanificacionCambios}
        className="calidad-hub-card"
      >
        <span className="calidad-hub-card-icon">
          <CalendarClock size={22} />
        </span>

        <div className="calidad-hub-card-body">
          <div className="calidad-hub-card-eyebrow">ISO 9001-14001</div>
          <h2 className="calidad-hub-card-title">Planificación de cambios</h2>
          <p className="calidad-hub-card-copy">
            Mantiene la planificación de cambios, responsables, recursos, estado, seguimiento y control documental.
          </p>
        </div>

        <span className="calidad-hub-card-action">
          Abrir
          <ArrowRight size={16} />
        </span>
      </button>


      <button
        type="button"
        onClick={onOpenDafo}
        className="calidad-hub-card"
      >
        <span className="calidad-hub-card-icon">
          <ClipboardList size={22} />
        </span>

        <div className="calidad-hub-card-body">
          <div className="calidad-hub-card-eyebrow">ISO 9001-14001</div>
          <h2 className="calidad-hub-card-title">DAFO / Partes interesadas</h2>
          <p className="calidad-hub-card-copy">
            Gestiona el DAFO anual y las partes interesadas con plantilla anual partiendo del ejercicio anterior.
          </p>
        </div>

        <span className="calidad-hub-card-action">
          Abrir
          <ArrowRight size={16} />
        </span>
      </button>


      <button
        type="button"
        onClick={onOpenRiesgosOportunidades}
        className="calidad-hub-card"
      >
        <span className="calidad-hub-card-icon">
          <TrendingUp size={22} />
        </span>

        <div className="calidad-hub-card-body">
          <div className="calidad-hub-card-eyebrow">ISO 9001-14001</div>
          <h2 className="calidad-hub-card-title">Riesgos y oportunidades</h2>
          <p className="calidad-hub-card-copy">
            Gestiona riesgos y oportunidades por año, con plantilla anual partiendo del ejercicio anterior.
          </p>
        </div>

        <span className="calidad-hub-card-action">
          Abrir
          <ArrowRight size={16} />
        </span>
      </button>


      <button type="button" onClick={onOpenMantenimientoVehiculos} className="calidad-hub-card">
        <span className="calidad-hub-card-icon"><Car size={22} /></span>
        <div className="calidad-hub-card-body"><div className="calidad-hub-card-eyebrow">ISO 9001-14001</div><h2 className="calidad-hub-card-title">Mantenimiento de vehículos</h2><p className="calidad-hub-card-copy">Gestiona vehículos e intervenciones de mantenimiento, sin incluir el consumo de gasolina.</p></div>
        <span className="calidad-hub-card-action">Abrir <ArrowRight size={16} /></span>
      </button>

      <button type="button" onClick={onOpenMantenimientoInfraestructuras} className="calidad-hub-card">
        <span className="calidad-hub-card-icon"><Building2 size={22} /></span>
        <div className="calidad-hub-card-body"><div className="calidad-hub-card-eyebrow">ISO 9001-14001</div><h2 className="calidad-hub-card-title">Mantenimiento de infraestructuras</h2><p className="calidad-hub-card-copy">Planifica el mantenimiento anual y crea plantillas selectivas desde ejercicios anteriores.</p></div>
        <span className="calidad-hub-card-action">Abrir <ArrowRight size={16} /></span>
      </button>

      <button type="button" onClick={onOpenControlOperacional} className="calidad-hub-card">
        <span className="calidad-hub-card-icon"><ClipboardCheck size={22} /></span>
        <div className="calidad-hub-card-body"><div className="calidad-hub-card-eyebrow">ISO 9001-14001</div><h2 className="calidad-hub-card-title">Control operacional</h2><p className="calidad-hub-card-copy">Organiza aspectos, pautas de inspección, resultados y firma anual del control operacional.</p></div>
        <span className="calidad-hub-card-action">Abrir <ArrowRight size={16} /></span>
      </button>

      <button type="button" onClick={onOpenFormacion} className="calidad-hub-card">
        <span className="calidad-hub-card-icon"><GraduationCap size={22} /></span>
        <div className="calidad-hub-card-body"><div className="calidad-hub-card-eyebrow">ISO 9001-14001</div><h2 className="calidad-hub-card-title">Formación</h2><p className="calidad-hub-card-copy">Consulta cursos por empleado y año, y registra la evaluación de la formación.</p></div>
        <span className="calidad-hub-card-action">Abrir <ArrowRight size={16} /></span>
      </button>
    </section>
  );
}
